import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarEnteConformador = () => {
  const [entes, setEntes] = useState([]);
  const navigate = useNavigate();

  // Función para obtener los datos de regionales
  const getData = useCallback(async () => {
    try {
      const { data } = await axios.get("/api/ente/listall/");

      // Asegurarse de que data.entesConformadores es un array
      if (data && Array.isArray(data.entesConformadores)) {
        const enteConFunciones = data.entesConformadores.map((ente) => ({
          ...ente,
          nombrePais: ente.paisObjectId?.nombrePais || "Pais no disponible",
          nombreEstado: ente.estadoObjectId?.nombreEstado || "Estado no disponible",
          nombreCiudad: ente.ciudadObjectId?.nombreCiudad || "Ciudad no disponible",

          funciones: (

        <div className="d-flex gap-2 justify-content-center">

              <button
                className="btn btn-secondary"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/enteconformador/asociar/jefeinmediato/${ente._id}`)}
                title="Asociar Rector"
              >
                <i className="fa-solid fa-link"></i>

              </button>

              <button
                className="btn btn-primary"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/enteconformador/resoluciones/${ente._id}`)}
                title="Listar Resoluciones"
              >
                <i className="fa-solid fa-list"></i>
              </button>
              <button
                className="btn btn-primary"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/enteconformador/resoluciones/registrar/${ente._id}`)}
                title="Registrar Resolución"
              >
                <i className="fa-solid fa-file-circle-plus"></i>
              </button>


              <button
                className="btn btn-warning"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/enteconformador/editar/${ente._id}`)}
                title="Editar Ente"
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>

              <button
                className="btn btn-danger"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => deleteEnte(ente._id)}
                title="Eliminar Ente"
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          ),
        }));

        setEntes(enteConFunciones.reverse());
      } else {
        throw new Error('Datos del Grupo no válidos.');
      }
    } catch (error) {
      console.error("Error al cargar los Entes Conformadores:", error.message);
    }
    // eslint-disable-next-line 
  }, []);

  // Ejecutar getData cuando el componente se monte
  useEffect(() => {
    getData();
  }, [getData]);  // No es necesario que getData sea una dependencia aquí


  // Función para eliminar una regional
  const deleteEnte = async (id) => {
    try {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await axios.delete(`/api/ente/${id}`);
          getData(); // Refrescar los datos de la lista
          Swal.fire({
            icon: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    } catch (error) {
      console.error('Error al eliminar el EnteConformador:', error.message);
      Swal.fire('Error', 'No se pudo eliminar el EnteConformador.', 'error');
    }
  };

  useEffect(() => {
    getData();
  }, [getData]);


  // Columnas de la tabla
  const columns = React.useMemo(() => [
    { Header: 'Dane', accessor: 'coddaneEnteconformador' },
    { Header: 'Nit', accessor: 'nitEnteconformador' },
    { Header: 'Nombre', accessor: 'nombreEnteconformador' },
    //{ Header: 'Dirección', accessor: 'direccionEnteconformador' },
    { Header: 'Teléfono 1', accessor: 'telefono1Enteconformador' },
    //{ Header: 'Zona', accessor: 'zonaEnteconformador' },
    //{ Header: 'Pais', accessor: 'nombrePais' },
    { Header: 'Estado', accessor: 'nombreEstado' },
    { Header: 'Ciudad', accessor: 'nombreCiudad' },
    { accessor: 'funciones' },
  ], []);

  return (
   <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1>Lista de Entes Conformadores</h1>
      {Array.isArray(entes) && entes.length > 0 ? (
        <DataTable columns={columns} data={entes} />
      ) : (
        <p>Cargando entesConformadores...</p>
      )}
    </div>
  );
};

export default ListarEnteConformador;
